import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { AuthContext } from '../../Auth/AuthContext'
import * as Yup from 'yup'
import ContentHeader from '../Layout/ContentHeader'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import Box from '../Global/Box'
import { yupResolver } from '@hookform/resolvers/yup'
import InputController from '../Global/InputController'
import QuestionsAdd from './components/QuestionsAdd'
import { inputQuestions } from './helpers/inputQuestions'
import { useMutation, useQuery } from '@apollo/client'
import { GET_ALL_SURVEYS_QUESTION_TYPE } from '../../graphql/Catalog/Surveys/surveysQuestionType'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import {
  CREATE_SURVEY,
  GET_ONE_SURVEY_BY_ID,
  UPDATE_SURVEY,
} from '../../graphql/Catalog/Surveys/surveys'
import { GET_ONE_BY_ONE_SURVEY_BY_ID } from '../../graphql/Catalog/Surveys/surveysanswersuser'
import PaginationSurveyReview from './components/PaginationSurveyReview'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'

const SurveysNew = () => {
  //history
  const history = useHistory()

  //LOADING
  const { showLoading, hideLoading } = useLoading()

  const { id: _id, show } = useParams(AuthContext)
  const [questionsEdit, setQuestionsEdit] = useState([])
  const [optionsQuestions, setOptionsQuestions] = useState([])
  const [idsToDeleteQuestions, setIdsToDeleteQuestions] = useState([])
  const [idsToDeleteOptions, setIdsToDeleteOptions] = useState([])

  //PAGINATION ANSWERS STATES
  const [prevUserId, setPrevUserId] = useState(null)
  const [nextUserId, setNextUserId] = useState(null)
  const [currentUserId, setCurrentUserId] = useState(null)
  const [totalAnswers, setTotalAnswers] = useState(0)
  const [searchIndex, setSearchIndex] = useState(1)
  const [valueSearchIndex, setValueSearchIndex] = useState(0)
  const [currentPosition, setCurrentPosition] = useState(1)

  const schemaValidation = show
    ? Yup.object().shape({
        title: Yup.string(),
        description: Yup.string(),
        questions: Yup.array().of(
          Yup.object().shape({
            type_question_id: Yup.number(),
            question_text: Yup.string(),
            key_type_question: Yup.string(),
            min: Yup.string(),
            max: Yup.string(),
            value: Yup.string(),
            options: Yup.array().of(
              Yup.object().shape({
                option_text: Yup.string(),
              })
            ),
            responses: Yup.array().of(
              Yup.object().shape({
                question_id: Yup.number(),
                question_option_id: Yup.number(),
                answer_text: Yup.string(),
                value: Yup.string(),
              })
            ),
          })
        ),
      })
    : Yup.object().shape({
        title: Yup.string().required('El titulo es requerido'),
        description: Yup.string(),
        // start_date: Yup.string().required('La fecha de inicio es requerida'),
        // end_date: Yup.string().required('La fecha de fin es requerida'),
        questions: Yup.array().of(
          Yup.object().shape({
            type_question_id: Yup.number().required(
              'El tipo de pregunta es requerido'
            ),
            question_text: Yup.string().required(
              'El texto de la pregunta es requerido'
            ),
            min: Yup.string().when('key_type_question', {
              is: (val) => val === 'raiting',
              then: Yup.string().required('El valor es requerido'),
              otherwise: Yup.string().nullable().notRequired().default(''),
            }),
            max: Yup.string().when('key_type_question', {
              is: (val) => val === 'raiting',
              then: Yup.string().required('El valor es requerido'),
              otherwise: Yup.string().nullable().notRequired().default(''),
            }),
            value: Yup.string().when('key_type_question', {
              is: (val) => val === 'raiting',
              then: Yup.string().required('El valor es requerido'),
              otherwise: Yup.string().nullable().notRequired().default(''),
            }),
            is_required: Yup.string().notRequired().default('false'),
            key_type_question: Yup.string(),
            options: Yup.array().when('key_type_question', {
              is: (val) => val === 'multi-choice',
              then: Yup.array().of(
                Yup.object().shape({
                  option_text: Yup.string().required(
                    'El texto de la opción es requerido'
                  ),
                })
              ),
              otherwise: Yup.array().when('key_type_question', {
                is: (val) => val === 'raiting',
                then: Yup.array().of(
                  Yup.object()
                    .shape({
                      option_text: Yup.string()
                        .nullable()
                        .notRequired()
                        .default(''),
                    })
                    .nullable()
                    .notRequired()
                    .default([])
                ),
                otherwise: Yup.array().when('key_type_question', {
                  is: (val) => val === 'choosen',
                  then: Yup.array().of(
                    Yup.object().shape({
                      option_text: Yup.string().required(
                        'El texto de la opción es requerido'
                      ),
                    })
                  ),
                  otherwise: Yup.array().nullable().notRequired().default([]),
                }),
              }),
            }),
          })
        ),
      })

  console.log('schemaValidation', schemaValidation)

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schemaValidation),
    // defaultValues: {
    //   questions: [{ question: '', options: [''] }],
    // },
  })

  // console.log('errors', errors)
  const {
    loading: loadingSurvey,
    data: dataSurvey,
    error: errorSurvey,
  } = useQuery(GET_ONE_SURVEY_BY_ID, {
    variables: {
      id: +_id,
    },
    fetchPolicy: 'cache-first',
    skip: show,
  })

  const {
    loading: loadingSurveyAnswers,
    data: dataSurveyAnswers,
    error: errorSurveyAnswers,
    refetch: refetchSurveyAnswers,
  } = useQuery(GET_ONE_BY_ONE_SURVEY_BY_ID, {
    variables: {
      surveyId: +_id,
      userId: +currentUserId,
      searchByIndex: valueSearchIndex ? +valueSearchIndex : null,
      // limit: 1,
      // offset: 0,
    },
    skip: !show,
  })

  const {
    loading: loadingTypesQuestions,
    data: dataTypesQuestions,
    error: errorTypesQuestions,
  } = useQuery(GET_ALL_SURVEYS_QUESTION_TYPE, {})

  const [createSurveyMutation] = useMutation(CREATE_SURVEY)
  const [updateSurveyMutation] = useMutation(UPDATE_SURVEY)

  useEffect(() => {
    try {
      if (loadingTypesQuestions) return
      if (errorTypesQuestions)
        return toastSweetAlert({
          mode: 'error',
          message: errorTypesQuestions.message,
        })

      const options = dataTypesQuestions.getAllSurveyQuestionType.rows.map(
        (item) => {
          return {
            value: item.id,
            label: item.name,
            key: item.key,
          }
        }
      )

      setOptionsQuestions(options)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTypesQuestions, dataTypesQuestions, errorTypesQuestions])

  useEffect(() => {
    try {
      if (show) return
      if (!_id) return
      if (loadingSurvey) return
      if (errorSurvey)
        return toastSweetAlert({
          mode: 'error',
          message: errorSurvey.message,
        })

      const survey = dataSurvey.getOneSurveysById

      const questions = survey.surveysToSurveysQuestions.map((question) => {
        return {
          id: question.id,
          question_text: question.question_text,
          type_question_id: question.type_question_id,
          key_type_question: question.surveysQuestionsTosurveyQuestionType.key,
          min:
            question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
              ? question.surveysQuestionsToSurveyQuestionOptions.find(
                  (option) => {
                    if (
                      option.order === 1 &&
                      option.question_id === question.id
                    ) {
                      return String(option.option_text.trim())
                    }
                  }
                ).option_text
              : '',
          max:
            question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
              ? question.surveysQuestionsToSurveyQuestionOptions.find(
                  (option) => {
                    if (
                      option.order === 2 &&
                      option.question_id === question.id
                    ) {
                      return String(option.option_text.trim())
                    }
                  }
                ).option_text
              : '',
          value:
            question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
              ? question.surveysQuestionsToSurveyQuestionOptions.find(
                  (option) => {
                    // console.log('option', option)
                    if (
                      option.order === 2 &&
                      option.question_id === question.id
                    ) {
                      return +option.value
                    }
                  }
                ).value
              : '',
          is_required: question.is_required ? true : false,
          options: question.surveysQuestionsToSurveyQuestionOptions.map(
            (option) => {
              return {
                id: option.id,
                option_text: option.option_text,
                value: option.value,
              }
            }
          ),
        }
      })

      reset({
        title: survey.title,
        description: survey.description,
        questions,
      })

      setQuestionsEdit(questions)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingSurvey, dataSurvey, errorSurvey, _id])

  useEffect(() => {
    try {
      if (!show) return
      if (loadingSurveyAnswers) return
      if (errorSurveyAnswers)
        return toastSweetAlert({
          mode: 'error',
          message: errorSurveyAnswers.message,
        })

      let surveyInfo = {}
      // let questions = []
      // let questionOptions = []
      let responses = []

      const surveyData = dataSurveyAnswers.getOneByOneSurveyAnswerUser.rows

      if (dataSurveyAnswers.getOneByOneSurveyAnswerUser.count === 0) {
        return toastSweetAlert(
          {
            mode: 'modalConfirmCancel',
            icon: 'info',
            message: 'Aun no hay respuestas',
          },
          setCurrentPosition(currentPosition)
        )
      }

      const questions = surveyData.map((row) => {
        surveyInfo = row.surveysAnswerUserToSurveys
        return row.surveysAnswerUserToSurveys.surveysToSurveysQuestions.map(
          (question) => {
            return {
              id: question.id,
              question_text: question.question_text,
              type_question_id: question.type_question_id,
              key_type_question:
                question.surveysQuestionsTosurveyQuestionType.key,
              min:
                question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
                  ? question.surveysQuestionsToSurveyQuestionOptions.find(
                      (option) => {
                        if (
                          option.order === 1 &&
                          option.question_id === question.id
                        ) {
                          return String(option.option_text.trim())
                        }
                      }
                    ).option_text
                  : '',
              max:
                question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
                  ? question.surveysQuestionsToSurveyQuestionOptions.find(
                      (option) => {
                        if (
                          option.order === 2 &&
                          option.question_id === question.id
                        ) {
                          return String(option.option_text.trim())
                        }
                      }
                    ).option_text
                  : '',
              value:
                question.surveysQuestionsTosurveyQuestionType.key === 'raiting'
                  ? question.surveysQuestionsToSurveyQuestionOptions.find(
                      (option) => {
                        if (
                          option.order === 2 &&
                          option.question_id === question.id
                        ) {
                          return +option.value
                        }
                      }
                    ).value
                  : '',
              options: question.surveysQuestionsToSurveyQuestionOptions.map(
                (option) => {
                  return {
                    id: option.id,
                    option_text: option.option_text,
                    value: option.value,
                  }
                }
              ),
            }
          }
        )
      })

      responses = surveyData.map((row) => {
        return {
          question_id: row.question_id,
          question_option_id: row.question_option_id,
          answer_text: row.answer_text,
        }
      })

      const questionsFomat = questions[0].map((question, idx) => {
        const filterResponses = responses.filter(
          (response) => response.question_id === question.id
        )

        if (filterResponses) {
          return {
            ...question,
            responses: filterResponses,
          }
        }

        return question
      })

      questionsFomat.sort((a, b) => a.id - b.id)

      reset({
        title: surveyInfo.title,
        description: surveyInfo.description,
        questions: questionsFomat,
        responses,
      })

      setCurrentPosition(searchIndex ? searchIndex : currentPosition)
      setNextUserId(dataSurveyAnswers.getOneByOneSurveyAnswerUser.nextUserId)
      setPrevUserId(dataSurveyAnswers.getOneByOneSurveyAnswerUser.prevUserId)
      setQuestionsEdit(questions)
      setTotalAnswers(dataSurveyAnswers.getOneByOneSurveyAnswerUser.count)
      setSearchIndex(null)
      setTimeout(() => {
        return toastSweetAlert({
          mode: 'okToast',
          message: 'Respuestas cargadas correctamente',
        })
      }, 500)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [show, dataSurveyAnswers, loadingSurveyAnswers, errorSurveyAnswers])

  useEffect(() => {
    if (show && searchIndex && searchIndex !== currentPosition) {
      setValueSearchIndex(searchIndex)
      setCurrentUserId(null)
    }
  }, [searchIndex])

  const onSubmit = async (data) => {
    showLoading()
    try {
      // console.log('data', data)
      if (show) {
        return toastSweetAlert({
          mode: 'loading',
          message: 'Cargando respuestas, espera un momento',
        })
      }

      if (_id) {
        // update
        const { data: dataSurveyUpdated } = await updateSurveyMutation({
          variables: {
            updateSurveyId: +_id,
            input: {
              title: data.title,
              description: data.description,
              questions: data.questions.map((question) => {
                return {
                  id: +question.id === 0 ? null : +question.id,
                  question_text: question.question_text,
                  type_question_id: question.type_question_id,
                  key_type_question: question.key_type_question,
                  min: question.min,
                  max: question.max,
                  value: question.value,
                  is_required: question.is_required === 'true' ? true : false,
                  questionOptions:
                    question.key_type_question === 'multi-choice' ||
                    question.key_type_question === 'choosen' ||
                    (question.key_type_question === 'raiting' && question.id)
                      ? question.options.map((option) => {
                          return {
                            id: +option.id,
                            question_id: +question.id,
                            option_text: option.option_text,
                            value: option.value,
                          }
                        })
                      : [],
                }
              }),
            },
            idsDeleteQuestionsOptions: idsToDeleteOptions,
            idsDeleteQuestions: idsToDeleteQuestions,
          },
        })

        if (dataSurveyUpdated.updateSurvey) {
          return toastSweetAlert({
            mode: 'ok',
            message: 'La encuesta se ha actualizado correctamente',
          })
        }
      }

      // create

      const { data: dataSurveyCreated } = await createSurveyMutation({
        variables: {
          input: {
            title: data.title,
            description: data.description,
            questions: data.questions.map((question) => {
              return {
                question_text: question.question_text,
                type_question_id: question.type_question_id,
                key_type_question: question.key_type_question,
                min: question.min,
                max: question.max,
                value: question.value,
                is_required: question.is_required === 'true' ? true : false,
                questionOptions:
                  question.key_type_question === 'multi-choice' ||
                  question.key_type_question === 'choosen'
                    ? question.options.map((option) => {
                        return {
                          option_text: option.option_text,
                        }
                      })
                    : [],
              }
            }),
            // idsDeleteQuestionsOptions: idsToDeleteOptions,
            // idsDeleteQuestions: idsToDeleteQuestions,
          },
        },
      })

      if (dataSurveyCreated.createSurvey) {
        return toastSweetAlert({
          mode: 'ok',
          message: 'La encuesta se ha creado correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      history.push('/surveys')
    }
  }

  return (
    <>
      <ContentHeader
        title={
          _id ? (show ? 'Respuestas' : 'Editar Encuesta') : 'Crear Encuesta'
        }
        breadcrumb=""
        windowTitle={
          _id ? (show ? 'Respuestas' : 'Editar Encuesta') : 'Crear Encuesta'
        }
      />

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            contentHeader={
              <>
                <div className="d-flex justify-content-center">
                  <h3 className="card-title pl-3 mt-0">Encuesta</h3>
                  {show && (
                    <PaginationSurveyReview
                      prevUserId={prevUserId}
                      setPrevUserId={setPrevUserId}
                      nextUserId={nextUserId}
                      setNextUserId={setNextUserId}
                      currentUserId={currentUserId}
                      setCurrentUserId={setCurrentUserId}
                      totalAnswers={totalAnswers}
                      setTotalAnswers={setTotalAnswers}
                      currentPosition={currentPosition}
                      setCurrentPosition={setCurrentPosition}
                      setSearchIndex={setSearchIndex}
                      searchIndex={searchIndex}
                    />
                  )}
                </div>
              </>
            }
            btnRedPath="/surveys"
            btnRedTxt="Cancelar"
            btnSubmit={!show}
            btnSubmitText={
              _id
                ? show
                  ? 'Enviar Respuestas'
                  : 'Actualizar Encuesta'
                : 'Crear Encuesta'
            }
            errors={errors}
            cardFooter={
              <>
                {show && (
                  <div className="d-flex justify-content-center">
                    {show && (
                      <PaginationSurveyReview
                        prevUserId={prevUserId}
                        setPrevUserId={setPrevUserId}
                        nextUserId={nextUserId}
                        setNextUserId={setNextUserId}
                        currentUserId={currentUserId}
                        setCurrentUserId={setCurrentUserId}
                        totalAnswers={totalAnswers}
                        setTotalAnswers={setTotalAnswers}
                        currentPosition={currentPosition}
                        setCurrentPosition={setCurrentPosition}
                        setSearchIndex={setSearchIndex}
                        searchIndex={searchIndex}
                      />
                    )}
                  </div>
                )}
              </>
            }
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12">
                    <h2>Encuesta</h2>
                  </div>
                  <div className="mb-3 col-12">
                    <hr />
                  </div>

                  <div className="mb-3 col-md-12 col-lg-6">
                    <InputController
                      label="Titulo"
                      name="title"
                      control={control}
                      placeholder="Titulo de la encuesta"
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-12">
                    <InputController
                      label="Descripción"
                      name="description"
                      control={control}
                      inputType="textarea"
                      placeholder="Descripción de la encuesta"
                      disabled={show}
                    />
                  </div>
                </div>
                <hr />

                <div>
                  <h3>Preguntas</h3>
                  <div className="row">
                    <QuestionsAdd
                      prefix="questions"
                      control={control}
                      idsToDeleteQuestions={idsToDeleteQuestions}
                      setIdsToDeleteQuestions={setIdsToDeleteQuestions}
                      idsToDeleteOptions={idsToDeleteOptions}
                      setIdsToDeleteOptions={setIdsToDeleteOptions}
                      optionsQuestions={optionsQuestions}
                      inputs={inputQuestions}
                      setValue={setValue}
                      questionsEdit={questionsEdit}
                      surveyId={_id}
                      getValues={getValues}
                      reset={reset}
                      show={show}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default SurveysNew
